"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function createContextStore(initState, dispatch) {
    if (dispatch === void 0) { dispatch = function () {
        // dispatch
    }; }
    return react_1.createContext({
        dispatch: dispatch,
        state: initState
    });
}
exports.createContextStore = createContextStore;
function createContextValueFn(initState, reducers) {
    return function (customInitState, customDispatch) {
        var _a = react_1.useReducer(reducers, __assign(__assign({}, initState), customInitState)), state = _a[0], dispatch = _a[1];
        return ({
            dispatch: customDispatch ? customDispatch : dispatch,
            state: state
        });
    };
}
exports.createContextValueFn = createContextValueFn;
exports.default = {
    createContextStore: createContextStore,
    createContextValueFn: createContextValueFn
};
